/* eslint jsx-a11y/anchor-has-content:0 */
// TODO(markn): disabled this rule due to legal blocking using DLS

import * as React from 'react'

import {
  Colors,
  InlineChildren,
  Spacing,
  StackChildren,
  Text,
} from '@doordash/design-language'

import { CANADA_BACKGROUND_CHECK_URL } from '../../../constants'

import { trackPendingBackgroundCheckFormRendered } from '../../../events'

import { Application } from 'src/utilities/application/application'
import t from './strings'

type Props = {
  application: Application
  virtual: any
}

// tslint:disable:max-line-length
class PreScreenDetail extends React.Component<Props> {
  public componentDidMount() {
    trackPendingBackgroundCheckFormRendered()
  }

  public render() {
    const { virtual, application } = this.props
    const explanation = virtual
      ? t.explanationPickUp()
      : t.explanationOrientation()
    return (
      <StackChildren size={Spacing.Large}>
        <Text color={Colors.SystemRed60} styles={Text.Styles.MajorPageTitle}>
          {t.nextSteps()}
        </Text>
        <Text color={Text.Colors.TextTertiary} weight={Text.Weights.Regular}>
          {explanation}
        </Text>

        {!virtual && (
          <Text
            styles={Text.Styles.PageDescriptionBody}
            lineHeight={Text.LineHeights.Large}
            color={Text.Colors.TextTertiary}
            weight={Text.Weights.Regular}
          >
            {t.orientationInfo()}
          </Text>
        )}

        <Text
          styles={Text.Styles.PageDescriptionBody}
          lineHeight={Text.LineHeights.Large}
          color={Text.Colors.TextTertiary}
          weight={Text.Weights.Regular}
        >
          {t.questionsOne()}{' '}
          <a href="https://www.doordash.com/help/">
            https://www.doordash.com/help/
          </a>
          . {t.questionsTwo()}
        </Text>

        <InlineChildren
          justifyContent={InlineChildren.Justification.SpaceBetween}
        >
          <Text styles={Text.Styles.Bold18} color={Colors.TextAction}>
            <a
              href="https://www.doordash.com/about/"
              style={{ color: 'inherit' }}
              target="_blank"
              rel="noopener noreferrer"
            >
              {t.aboutDoorDash()}
            </a>
          </Text>
          <Text styles={Text.Styles.Bold18} color={Colors.TextAction}>
            <a
              href="https://help.doordash.com/dashers/s/"
              style={{ color: 'inherit' }}
              target="_blank"
              rel="noopener noreferrer"
            >
              {t.dasherFaqs()}
            </a>
          </Text>
        </InlineChildren>

        {application.country === 'CA' && (
          <a href={CANADA_BACKGROUND_CHECK_URL} target="_blank">
            {t.stillNeedToSubmit()}
          </a>
        )}
      </StackChildren>
    )
  }
}

export default PreScreenDetail
